import { TrixUser } from './trix-user';

export class Customer {
  constructor(public id?: number,
              public name?: string,
              public city?: string,
              public contactName?: string,
              public trixUser?: TrixUser,
              public equipmentBagStayInCustomer?: boolean,
              public equipmentAwaitingReturnOnCustomer?: boolean,
              public contactPhone?: string) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/model/customer.ts